import { Platform, StyleSheet, Text, View } from 'react-native'
import { colors, fontWeight, radius } from '../tokens'

type Props = {
  to: string
  subject: string
  attachmentReady: boolean
}

const DocIcon = () =>
  Platform.OS === 'web' ? (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={14}
      height={14}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M9 13h6M9 17h6" />
    </svg>
  ) : null

// The email-preview card under Step 2. The attachment chip is the device
// that ties Step 1 to Step 2 — dashed grey before download, solid mint
// after — so the user understands attaching the PDF is the bridge.
export const FulfilmentEmailPreview = ({ to, subject, attachmentReady }: Props) => (
  <View style={styles.card}>
    <View style={styles.row}>
      <Text style={styles.key}>To</Text>
      <Text style={styles.val} numberOfLines={1}>
        {to}
      </Text>
    </View>
    <View style={[styles.row, styles.rowLast]}>
      <Text style={styles.key}>Subject</Text>
      <Text style={styles.val} numberOfLines={1}>
        {subject}
      </Text>
    </View>
    <View style={[styles.attach, attachmentReady && styles.attachReady]}>
      <View style={[styles.chip, attachmentReady && styles.chipReady]}>
        <DocIcon />
        <Text
          style={[styles.chipText, attachmentReady && styles.chipTextReady]}
          testID="fulfilment-attachment-chip"
        >
          evidence-appendix.pdf
        </Text>
      </View>
      <Text style={[styles.note, attachmentReady && styles.noteReady]}>
        {attachmentReady ? 'Ready to attach from step 1' : 'Download it in step 1 first'}
      </Text>
    </View>
  </View>
)

const styles = StyleSheet.create({
  card: {
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: radius.sm,
    overflow: 'hidden',
    marginBottom: 16,
    backgroundColor: colors.surface,
  },
  row: {
    flexDirection: 'row',
    gap: 12,
    paddingVertical: 11,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  rowLast: { borderBottomWidth: 1 },
  key: { color: colors.faint, width: 58, fontSize: 13.5, fontWeight: fontWeight.medium },
  val: { color: colors.ink, fontSize: 13.5, fontWeight: fontWeight.medium, flex: 1 },
  attach: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: colors.surface2,
    flexWrap: 'wrap',
  },
  attachReady: {},
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 6,
    paddingHorizontal: 11,
    borderRadius: 8,
    borderWidth: 1.5,
    borderColor: colors.borderStrong,
    borderStyle: 'dashed',
    backgroundColor: colors.surface,
  },
  chipReady: {
    borderStyle: 'solid',
    borderColor: colors.positive,
    backgroundColor: colors.positiveSoft,
  },
  chipText: { color: colors.muted, fontSize: 13.5, fontWeight: fontWeight.semibold },
  chipTextReady: { color: colors.positiveInk },
  note: { color: colors.muted, fontSize: 12.5 },
  noteReady: { color: colors.positiveInk },
})
